import DayIsDisplay from './DayIsDisplay'
import DayIsForm from './DayIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconDay from 'components/Icons/Day'

export default {
  id: 'day_is',
  label: 'Day is',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/day-is',
  icon: IconDay,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: DayIsDisplay,
  form: DayIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/DayIs/index.js